import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { BellPlus, Loader2 } from "lucide-react";
import { api, errText } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export const LitterAlertButton = ({ params, fr }) => {
  const { user, setAuthOpen } = useAuth();
  const [busy, setBusy] = useState(false);
  const breed = params.get("breed") || "";
  const species = params.get("species") || "";
  const province = params.get("province") || "";
  const ready = breed || species;
  const create = async () => {
    if (!user) return setAuthOpen(true);
    if (!ready) return toast.info(fr ? "Choisissez d'abord une race ou une espèce" : "Pick a breed or species first");
    setBusy(true);
    try {
      const { data } = await api.post("/my/litter-alerts", { breed, species, province });
      const msg = data.existed ? (fr ? "Vous avez déjà cette alerte. Elle est active." : "You already have this alert. It's on.") : (fr ? "Alerte créée! Nous vous écrirons dès qu'une portée correspond." : "Alert set! We'll email you when a matching litter is posted.");
      toast.success(msg, { action: { label: fr ? "Gérer" : "Manage", onClick: () => { window.location.href = "/dashboard?tab=saved"; } } });
    } catch (e) { toast.error(errText(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <button onClick={create} disabled={busy} data-testid="litters-alert-btn"
        className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-[#12234A] hover:bg-[#1d3366] text-white text-sm font-semibold transition-colors disabled:opacity-60">
        {busy ? <Loader2 size={16} className="animate-spin" /> : <BellPlus size={16} />} {fr ? "M'alerter des nouvelles portées" : "Alert me about new litters"}
      </button>
      <span className="text-xs text-slate-500" data-testid="litters-alert-hint">
        {ready ? (fr ? "Utilise la race, l'espèce et la province choisies." : "Uses the breed, species and province you've picked.") : (fr ? "Choisissez une race ou une espèce pour créer une alerte." : "Pick a breed or species to set an alert.")}
        {user && <> · <Link to="/dashboard?tab=saved" className="text-[#F5551E] hover:underline" data-testid="litters-alert-manage">{fr ? "Mes alertes" : "My alerts"}</Link></>}
      </span>
    </div>
  );
};
